export default {
    sim_provider_accounts_title: "SIM Provider Accounts",
    sim_provider_accounts_name: "Account Name",
    sim_provider_accounts_sim_provider: "SIM Provider",
    sim_provider_accounts_add: "Add SIM Provider Account",
    sim_provider_accounts_edit_title: "Edit SIM Provider Account",
    sim_provider_accounts_delete_title: "Delete SIM Provider Account",
    sim_provider_accounts_sim_type: "SIM Type",
}